<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5">
      <v-card-title>
        <h6 class="primary--text">Liste des chaînes de valeur</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('create value chain')">
          <export-excel :data="chains" name="Chains.xls" :export-fields="chains_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create value chain')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="Nom de la chaîne de valeur" solo></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" rounded @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" :loading="load" :disabled="load" rounded @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher un maillon" single-line solo
          hide-details>
        </v-text-field>

      </v-card-title>
    </v-card>

    <v-data-table :headers="headers" :items="chains" :loading="loading" loading-text="Loading..." sort-by="name"
      :search="search" class="elevation-1">

      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-if="$can('edit value chain')">
          mdi-pencil-outline
        </v-icon>
        <v-icon small @click="deleteItem(item)" v-if="$can('delete value chain')">
          mdi-trash-can-outline
        </v-icon>
      </template>

    </v-data-table>


    <v-layout row justify-center>
      <v-dialog v-model="dialog_deletion" max-width="290">
        <v-card>
          <v-card-title class="headline">Suppression</v-card-title>
          <v-card-text class="text-center">
            Etes-vous sûr de vouloir supprimer cette chaîne de valeur ?
          </v-card-text>

          <v-card-actions>

            <v-btn color="orange" rounded @click="dialog_deletion = false">
              <span class="white-couleur">Non</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" rounded :loading="load" :disabled="load" @click="delChain()">
              Oui
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>


  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-maillon',
  mixins: [Permissions],
  data: () => ({
    del_chain: null,
    del_index: null,
    loading: false,
    load: false,
    search: '',
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
      { text: 'Chaîne de valeur', value: 'name' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    chains_fields: {
      "Chaîne de valeur": "name",
    },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      country_id: null,
    },
    defaultItem: {
      name: '',
      country_id: null,
    },

  }),

  created() {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    pays() { return this.$store.getters.countries; },
    chains() { return this.$store.getters.chains; },
    formTitle() {
      return this.editedIndex === -1 ? 'Nouvelle chaine de valeur' : 'Editer la chaine de valeur'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  methods: {
    fetchUtils() {
      this.$store.dispatch("fetchCountries");
      this.$store.dispatch("fetchChains");
    },

    editItem(item) {
      this.editedIndex = this.chains.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem(item) {
      this.del_index = this.chains.indexOf(item);
      this.dialog_deletion = true;
      this.del_chain = item;
    },

    close() {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save() {
      this.load = true;
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateChain", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Chaîne de valeur éditée avec succès !";
      }
      else {
        await this.$store.dispatch("createChain", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Chaîne de valeur enregistrée avec succès !";
      }
      this.close();
      this.load = false;
    },


    async delChain() {
      this.load = true;
      await this.$store.dispatch("deleteChain", this.del_chain);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Chaîne de valeur supprimée avec succès !";
      this.load = false;
    },

  }
};
</script>

<style scoped>
.couleur-orange {
  color: rgb(255, 152, 0);

  font-size: 1.2em;
}

.white-couleur {
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/chains/list.vue